var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#73DC73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.87 4.62941C10.5432 4.37462 10.0662 4.4243 9.8021 4.7445L6.26103 9.03778L4.78034 7.82844C4.45932 7.56626 3.98138 7.6056 3.71006 7.91959C3.43554 8.23726 3.47915 8.7121 3.8038 8.97726L5.87922 10.6723C6.03653 10.8008 6.23925 10.8614 6.4416 10.842C6.644 10.8227 6.8314 10.7247 6.96063 10.568L10.9884 5.68467C11.2556 5.36073 11.2005 4.88706 10.87 4.62941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.416558822e9ee3da78fd808f2c2b1e6f.svg";
export { ForwardRef as ReactComponent };